<div class="surface-card p-5 m-3 shadow-1 border-round">
  <div class="font-medium text-2xl text-700 mb-3">
    <i class="pi pi-ticket"></i>
    Comprobante
  </div>
  <div
    *ngFor="let receipt of receipts"
    class="hover:bg-primary p-field-checkbox surface-border border-1 p-3 cursor-pointer surface-card"
  >
    <p-radioButton
      class="p-element ng-untouched ng-pristine ng-valid"
      [inputId]="receipt.id"
      name="receipt"
      [value]="receipt"
      [(ngModel)]="selectedReceipt"
      (onClick)="onSelectReceipt(receipt)"
    ></p-radioButton>
    <label [for]="receipt.id" class="ml-2 font-medium text-xl">
      {{ receipt.name }}
    </label>
  </div>
</div>
